// ProgressInquiry.tsx

import * as React from 'react';
import HistoryRecord from './Components/HistoryRecord/HistoryRecord';
import CustomMenu from '../../components/CustomMenu/CustomMenu';

/**
 * 進捗照会ページコンポーネント
 * - カスタムメニュー内に申請進捗履歴一覧を表示する
 */
export default function ProgressInquiry() {
  return (
    <CustomMenu>
      <HistoryRecord />
    </CustomMenu>
  );
}
